import React from "react";
import PropTypes from "prop-types";
import Box from "@mui/material/Box";
import Tooltip from "@mui/material/Tooltip";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";

import { getPropertyValue } from "../../../utils/helpers";
import { useGetApiDataQuery } from "../../../api/forms.api.slice";
import { getFieldProps } from "../../Form/services/form.service";
import { black80, white } from "../../../theme/color.constants";

const getOptions = (response, componentKey) => {
  if (Array.isArray(response)) return response;
  if (response?.data?.values) return response.data.values;
  if (!componentKey || !response) return [];
  return (
    getFieldProps(response, [componentKey]).find((c) => c?.data?.values)?.data
      ?.values ?? []
  );
};

function InfoTooltip(props) {
  const {
    data,
    config: { displayName, systemName, url, params, componentKey } = {},
  } = props;
  const rawValue = getPropertyValue(data, systemName);
  const { data: response } = useGetApiDataQuery(
    { url, params },
    { skip: !url || !rawValue }
  );

  if (!rawValue) return null;

  const value =
    getOptions(response, componentKey).find((o) => o?.value === rawValue)
      ?.label || rawValue;
  const title = displayName ? `${displayName}: ${value}` : value;

  return (
    <Tooltip title={title}>
      <Box
        component="span"
        tabIndex={0}
        role="img"
        aria-label={title}
        sx={{ display: "inline-flex", ml: "0.5rem", verticalAlign: "middle" }}
      >
        <InfoOutlinedIcon
          sx={(theme) => ({
            fontSize: "1.125rem",
            color: theme.palette.mode === "light" ? black80 : white,
          })}
        />
      </Box>
    </Tooltip>
  );
}

InfoTooltip.propTypes = {
  data: PropTypes.shape({}).isRequired,
  config: PropTypes.shape({
    displayName: PropTypes.string,
    systemName: PropTypes.string,
    url: PropTypes.string,
    params: PropTypes.shape({}),
    componentKey: PropTypes.string,
  }).isRequired,
};

export default InfoTooltip;
